import { render, staticRenderFns } from "./ModalMessageModel.vue?vue&type=template&id=af7d2c94"
import script from "./ModalMessageModel.vue?vue&type=script&lang=js"
export * from "./ModalMessageModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports